import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {TextUtils} from "../../../../../../shared/utils/text-utils";

@Component({
    selector: 'db-product-description',
    templateUrl: './product-description.component.html',
    styleUrls: ['./product-description.component.scss'],
    standalone: false
})
export class ProductDescriptionComponent implements OnInit {
  @Input() descriptionForm: FormGroup;
  openFirstTooltip = false;
  openSecondTooltip = false;
  shortGenerated = false;
  longGenerated = false;
  statusOptions = [
    {
      value: 'publish',
      label: TextUtils.getText('text_active')
    },
    {
      value: 'draft',
      label: TextUtils.getText('text_draft')
    },
  ];

  constructor() {
  }

  ngOnInit() {
  }
}
